// registry of all plugin actions and methods
export abstract class PluginRegistry {
  // "Astimax" plugin actions
  static readonly Astimax = {
    Actions: {
      PhoneModule: {
        START_CALL: 'astimax:phone:startCall' as const,
        BLIND_TRANSFER_CALL: 'astimax:phone:blindTransferCall' as const,
        PICK_CALL: 'astimax:phone:pickCall' as const,
        TOGGLE_VIDEO_FULLSCREEN: 'astimax:phone:toggleVideoFullscreen' as const
      }
    },
    Methods: {
      PhoneModule: {
        TRY_TOGGLE_VIDEO_FULLSCREEN: 'tryToggleVideoFullscreen' as const
      }
    } as const
  };
  
  // "X" plugin actions
  /*static readonly X = {
    ...
  };*/
}

// type helpers
export type AstimaxActions = typeof PluginRegistry.Astimax.Actions;
export type AstimaxMethods = typeof PluginRegistry.Astimax.Methods;
//export type PluginXActions = typeof PluginRegistry.PluginX.Actions;
//export type PluginXMethods = typeof PluginRegistry.PluginX.Methods;

// union type of all actions
export type AllPluginActions =
  | AstimaxActions[keyof AstimaxActions][keyof AstimaxActions[keyof AstimaxActions]];
  //| PluginXActions[keyof PluginXActions][keyof PluginXActions[keyof PluginXActions]];

// union type of all methods
export type AllPluginMethods =
  | AstimaxMethods[keyof AstimaxMethods][keyof AstimaxMethods[keyof AstimaxMethods]];
  //| PluginXMethods[keyof PluginXMethods][keyof PluginXMethods[keyof PluginXMethods]];
